import { ProposalEntity } from "../StandardProposal/ProposalEntity"

export interface ProposalCopyingForRecalEntity extends ProposalEntity {

    key: string,
    companyCode?: string | null,
    proposalNo?: string | null,
    proposalCreatedByMethod?: string | null,
    tariffNature?: string | null,
    tariffNatureList?: string[] | null,
    previousCompanyId?: string | null,
    companyType?: string | null,


    [key: string]: string | boolean | number | Date | null | undefined | Object
}

export const EMPTY_PROPOSAL_COPY_FOR_RECAL_ENTITY: ProposalCopyingForRecalEntity = {

    key: "",
    companyCode: "",
    proposalNo: null,
    operatingTml: "",
    effectiveDate: null,
    expiryDate: null,
    currencyCode: "",
    proposalCreatedByMethod: "",
    tariffNature: "",
    tariffNatureList: [],
    confirmedDate: null,
    status: 'NEW',
    rejectReason: null,
    remarks: "",
    submittedBy: null,
    previousCompanyId: null,
    companyType: null,
    proposalBy: 'RECAL'
}